import { render, staticRenderFns } from "./RoundPlanningView.vue?vue&type=template&id=3615d886"
import script from "./RoundPlanningView.vue?vue&type=script&lang=js"
export * from "./RoundPlanningView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports